module.exports = __webpack_public_path__ + "static/media/facebook-icon-blue.897db83d.svg";